import Hero from "./Component/Hero";
import React from "react";
import KeuntunganPerusahaanMitra from "./Component/KeuntunganPerusahaanMitra";
import ProductExplanation from "./Component/ProductExplanation";

function PerusahaanMitra() {
    return (
        <>
            <div>
                <Hero
                    imageClass='perusahaan-mitra'
                    title='Perusahaan Mitra'
                    subTitle=''
                    explanation={`
                        Danai.id hadir melengkapi Perusahaan dalam penyediaan Program Fasilitas Kesejahteraan Karyawan dan Program Masa Persiapan Pensiun (MPP).
                        <br/><br/>
                        Ingin menjadi Mitra atau informasi lebih lanjut? <a href="${process.env.REACT_APP_LINK_COMPANY_WEB}" class="text-white">Klik Disini</a>`}
                    />
                <ProductExplanation/>
                <KeuntunganPerusahaanMitra/>
            </div>
        </>
    );
}

export default PerusahaanMitra;